/**
 * @generated SignedSource<<3ccde3616734a111f53da6e5e1f8991e>>
 * @relayHash ab13c035f40ba0298bd82a325ff2c401
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41

import type { ConcreteRequest } from 'relay-runtime';
export type RecommendedPagesSpaceBehavior = "HIDDEN" | "SHOWN" | "%future added value";
export type EndOfPageRecommendationQuery$variables = {
  exp: string;
  id: string;
  key: string;
  keyString: string;
  type: string;
};
export type EndOfPageRecommendationQuery$data = {
  readonly getRecommendedPages: {
    readonly recommendedPages: ReadonlyArray<{
      readonly content: {
        readonly creatorId: string | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly history: {
          readonly ownedBy: {
            readonly displayName: string | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly space: {
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null;
      readonly strategy: ReadonlyArray<string>;
    }>;
  } | null;
  readonly getRecommendedPagesSpaceStatus: {
    readonly defaultBehavior: RecommendedPagesSpaceBehavior;
    readonly recommendedPagesEnabled: boolean;
  } | null;
  readonly space: {
    readonly id: string | null;
  } | null;
};
export type EndOfPageRecommendationQuery = {
  response: EndOfPageRecommendationQuery$data;
  variables: EndOfPageRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keyString"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "keyString"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v7 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "exp"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "subType"
},
v11 = {
  "kind": "ScalarField",
  "name": "creatorId"
},
v12 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v16 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v17 = {
  "kind": "ScalarField",
  "name": "strategy"
},
v18 = {
  "args": [
    {
      "kind": "Variable",
      "name": "entityId",
      "variableName": "key"
    }
  ],
  "concreteType": "RecommendedPagesSpaceStatus",
  "kind": "LinkedField",
  "name": "getRecommendedPagesSpaceStatus",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recommendedPagesEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "defaultBehavior"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EndOfPageRecommendationQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "RecommendedPages",
        "kind": "LinkedField",
        "name": "getRecommendedPages",
        "plural": false,
        "selections": [
          {
            "concreteType": "RecommendedPagesItem",
            "kind": "LinkedField",
            "name": "recommendedPages",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      },
      (v18/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndOfPageRecommendationQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "RecommendedPages",
        "kind": "LinkedField",
        "name": "getRecommendedPages",
        "plural": false,
        "selections": [
          {
            "concreteType": "RecommendedPagesItem",
            "kind": "LinkedField",
            "name": "recommendedPages",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      },
      (v18/*: any*/)
    ]
  },
  "params": {
    "cacheID": "ab13c035f40ba0298bd82a325ff2c401",
    "id": "e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41",
    "metadata": {},
    "name": "EndOfPageRecommendationQuery",
    "operationKind": "query",
    "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
  }
};
})();

(node as any).hash = "e939560761a450cc2ece30ee9466334e";

export default node;
